export default __webpack_public_path__ + "static/media/CE-Piktogramm.45036820.svg";